import { Params } from '@/helpers/convertEventsFromApi';

export const ERROR_MESSAGE: string =
  'Сбой в работе оборудования, повторите попытку позже.';

export interface IPurchases {}

export enum OrderStatusEnum {
  DIRECTED = 'directed',
  DEVELOPMENT = 'development',
  DELAYED = 'paused',
  EXECUTING = 'studying',
  CONFIRMED = 'approved',
  CANCELLED = 'cancelled',
  PENDING = 'pending',
  NEW = 'initial',
  COMPLETED = 'completed',
}

export interface ApiModel {
  children: Kids;
  events: Events;
  orders: Orders;
}

export const OrderStatusConfig = {
  studying: {
    status: 'Обучается',
    message: 'Желаем успехов!',
    variant: 'purple',
    sort: 200,
  },
  completed: {
    status: 'Закончил обучение',
    message: 'Желаем успехов!',
    variant: 'purple',
    sort: 200,
  },
  approved: {
    status: 'Подтверждена',
    message:
      'Ваша заявка подтверждена организатором, готовьтесь к началу обучения',
    variant: 'green',
    sort: 300,
  },
  cancelled: {
    status: 'Отменена',
    message: 'Оставьте заявку на другую программу',
    variant: 'grey',
    sort: 500,
  },
  initial: {
    status: 'Новая',
    message: 'Ожидайте, администратор учреждения свяжется с вами в ближайшее время',
    variant: 'red',
    sort: 100,
  },
  pending: {
    status: 'На рассмотрении',
    message: 'Желаем успехов!',
    variant: 'orange',
    sort: 200,
  },
  paused: {
    status: 'Отложена',
    message: 'Желаем успехов!',
    variant: '',
    sort: 200,
  },
  directed: {
    status: 'Направлена на разработку',
    message: 'Желаем успехов!',
    variant: '',
    sort: 200,
  },
  development: {
    status: 'В разработке',
    message: 'Желаем успехов!',
    variant: '',
    sort: 200,
  },
} as const;

export interface ApiData {
  data: ApiModel;
}

export interface Order {
  date: Date | string | number;
  id: Id;
  event_id: Id;
  kid_id: Id;
  sinse?: Date | string | number;
  status: OrderStatusEnum;
  deduct: string;
  academic_year?: string;
  pfdod_contracts?: Array<Contract>;
  certificate_on_hold?: null | undefined | string;
  certificate_amount_type?: null | undefined | string;
}

export interface Kid {
  id: Id;
  last_name: string;
  first_name: string;
  middle_name: string;
}

export interface Contract {
  serial: string | number;
  download_url: string;
}

export interface Event extends Params {
  id: Id;
}

export type Id = string | number;
export type Events = Array<Event>;
export type Kids = Array<Kid>;
export type Orders = Array<Order>;



// WEBPACK FOOTER //
// ./src/pages/profile/views/purchases/types.ts